import { useReveal, SpringParallax, Image, VideoLoop } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Caption$1 from '../Caption/Caption.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import StyledMediaRow from './MediaRow.style.js';

const MediaRow = ({
  itemsPerRow,
  items
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledMediaRow, {
    itemsPerRow: itemsPerRow,
    ref: ref
  }, items.map(item => /*#__PURE__*/React$1.createElement(SpringParallax, {
    className: "mediaRow__item",
    key: item.id
  }, /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible
  }, item.type === 'image' ? /*#__PURE__*/React$1.createElement(Image, {
    src: item.src,
    srcset: item.srcset,
    alt: item.alt,
    ratio: `${item.width}:${item.height}`
  }) : /*#__PURE__*/React$1.createElement(VideoLoop, {
    src: item.src,
    autoPlay: true,
    loop: true
  }), item.caption && /*#__PURE__*/React$1.createElement(Caption$1, {
    className: "mediaRow__item-meta",
    caption: item.caption,
    isVisible: isVisible
  })))));
};

MediaRow.propTypes = {
  itemsPerRow: PropTypes$1.oneOf(['2', '3']).isRequired,
  items: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};

export default MediaRow;
